import type { InterventionSectionUrlParamsKeys } from "./intervention-section-context.type";

export const INTERVENTION_SECTION_URL_PARAMS: Record<
  InterventionSectionUrlParamsKeys,
  string
> = {
  layoutIndex: "layout_index",
  assetId: "asset_id",
  observationId: "observation_id",
} as const;

export const INTERVENTION_SECTION_URL_PARAM_KEYS = Object.values(
  INTERVENTION_SECTION_URL_PARAMS
);
